import { TextField, Typography } from "@material-ui/core";
import InputLabel from "@material-ui/core/InputLabel";
import TableBody from "@material-ui/core/TableBody";
import TableRow from "@material-ui/core/TableRow";
import ColorButton from "components/common/ColorButton";
import FileType from "components/common/FileType";
import {
  StyledTableCell,
  TableRowHead,
  UploadButton,
  useStyles,
} from "components/request-document/components/Commons";
import useModalLoading from "libs/hooks/useModalLoading";
import { getFileObjectURL, getPathFile, openFileById } from "libs/utils/file";
import { getErrorMessage } from "libs/utils/form";
import { isError } from "lodash-es";
import { React } from "react";
import { useSelector } from "react-redux";
import { canEditForm } from "redux/modules/authSlice";
import FileService from "services/FileService";

export default function HealthInsurance({ formik }) {
  const classes = useStyles();
  const { showLoading, hideLoading } = useModalLoading();
  const canEdit = useSelector(canEditForm);
  const HealthInsuranceList = formik.values.HealthInsuranceList;

  return (
    <TableBody style={{ width: "100%" }}>
      <TableRowHead>
        <StyledTableCell colSpan={3}>
          <div className={classes.cellContent}>
            <div className={classes.wrapField}>
              <Typography variant="h6" className={classes.title}>
                Health Issuance
              </Typography>
            </div>
          </div>
        </StyledTableCell>
      </TableRowHead>

      <TableRow>
        <StyledTableCell colSpan={3}>
          <InputLabel>
            Please upload a reference file and enter expiry date about your
            Health Issuance.
          </InputLabel>
        </StyledTableCell>
      </TableRow>

      <TableRowHead>
        <StyledTableCell width={20}>
          <InputLabel>No.</InputLabel>
        </StyledTableCell>
        <StyledTableCell>
          <InputLabel>File Upload ( PDF, JPG )</InputLabel>
        </StyledTableCell>
        <StyledTableCell>
          <InputLabel>Expiry Date</InputLabel>
        </StyledTableCell>
      </TableRowHead>

      {HealthInsuranceList.map((item, index) => (
        <TableRow key={index}>
          <StyledTableCell>
            <div className={classes.cellContent}>
              <div className={classes.wrapField}>
                <InputLabel>{index + 1}</InputLabel>
              </div>
            </div>
          </StyledTableCell>
          <StyledTableCell>
            <div className={classes.cellContent}>
              <div className={classes.wrapField}>
                <div
                  style={{ display: "flex", justifyContent: "space-between" }}
                >
                  <FileType title="Document file" file={item.file} />
                  <div className={classes.flexRow}>
                    <UploadButton
                      title={item.FileID ? "Edit" : "BROWSE"}
                      disabled={item.disabled || !canEdit}
                      onChange={async (event) => {
                        try {
                          showLoading();

                          const response = await FileService.uploadFile({
                            file: event.target.files[0],
                            FileID: null,
                            Status: true,
                          });

                          const fileId = response.results?.fileID;
                          const path = response.results?.path;
                          const fileObj = await getFileObjectURL(
                            getPathFile(path)
                          );
                          const [filename, ext] =
                            event.target.files[0].name.split(".");

                          formik.setFieldValue(
                            `HealthInsuranceList.${index}.file`,
                            fileObj
                          );
                          // formik.setFieldValue(
                          //   `HealthInsuranceList.${index}.filename`,
                          //   filename
                          // );
                          formik.setFieldValue(
                            `HealthInsuranceList.${index}.FileID`,
                            fileId
                          );

                          hideLoading();
                        } catch (error) {
                          hideLoading();
                        }
                      }}
                    />
                    <ColorButton
                      fullWidth={false}
                      style={{ width: 82, marginLeft: 15, fontWeight: "bold" }}
                      variant="contained"
                      color="secondary"
                      size="large"
                      disabled={!item.FileID}
                      onClick={async () => {
                        openFileById(item.FileID);
                      }}
                    >
                      View
                    </ColorButton>
                  </div>
                </div>
              </div>
            </div>
          </StyledTableCell>
          <StyledTableCell>
            <div className={classes.cellContent}>
              <div className={classes.wrapField}>
                <TextField
                  variant="outlined"
                  className={classes.textField}
                  name={`HealthInsuranceList.${index}.expDate`}
                  type="date"
                  value={item.expDate}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  error={isError(
                    `HealthInsuranceList.${index}.expDate`,
                    formik
                  )}
                  helperText={getErrorMessage(
                    `HealthInsuranceList.${index}.expDate`,
                    formik
                  )}
                  disabled={item.disabled || !canEdit}
                />
              </div>
            </div>
          </StyledTableCell>
        </TableRow>
      ))}

      <div />
    </TableBody>
  );
}
